import { ShieldOff } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const Stat = ({ value, label, sub, accent = "text-brandamber", testid }) => (
  <div className="flex h-full flex-col justify-between rounded-2xl border border-white/10 bg-panel p-6 sm:p-8 transition-colors hover:border-white/25">
    <p className={`font-display text-5xl sm:text-6xl leading-none ${accent}`} data-testid={testid}>
      {value}
    </p>
    <div className="mt-6">
      <p className="font-semibold text-white">{label}</p>
      {sub && <p className="mt-2 text-sm leading-relaxed text-slate-400">{sub}</p>}
    </div>
  </div>
);

export const Threat = () => (
  <section id="threat" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="max-w-3xl text-base sm:text-lg font-semibold leading-relaxed text-slate-200">
          Lawyers are aggressively using AI to scan website accessibility and going after businesses by the
          thousands. Don't wait on a demand letter or a subpoena.
        </p>
        <h2 className="mt-4 max-w-3xl font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-white">
          NON-COMPLIANCE IS A <span className="text-alert">LAWSUIT</span> WAITING FOR AN ADDRESS.
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-5 md:grid-cols-2">
        <Reveal delay={0.05}>
          <Stat
            testid="stat-64"
            value="2/3"
            label="of lawsuits targeted companies under $25M revenue"
            sub="Small and mid-sized businesses are the preferred targets. A business can be sued in a state where it has no office."
            accent="text-alert"
          />
        </Reveal>
        <Reveal delay={0.1}>
          <Stat
            testid="stat-1in4"
            value="1 in 4"
            label="U.S. adults live with a disability"
            sub="When your site works for them, it works better for everyone — more customers, better SEO, tax credits."
            accent="text-cy"
          />
        </Reveal>
        <Reveal delay={0.15} className="md:col-span-2">
          <div className="flex h-full flex-col justify-between rounded-2xl border border-alert/40 bg-alert/10 p-6 sm:p-8">
            <ShieldOff className="h-8 w-8 text-alert" />
            <div className="mt-6">
              <p className="font-semibold text-white">
                1 in 4 sued sites already had an accessibility widget.
              </p>
              <p className="mt-2 text-sm leading-relaxed text-slate-300">
                A widget alone doesn't make a site conform. The biggest difference comes from fixing the actual code:
                labels, headings, contrast, alt text and keyboard access.
              </p>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.1} className="md:col-span-2">
          <div className="relative overflow-hidden rounded-2xl border border-white/10">
            <img
              src="https://images.unsplash.com/photo-1590252964816-2a42a263f3dc?auto=format&fit=crop&w=1600&q=80"
              alt="Dark laptop workspace showing website code under audit"
              className="h-52 w-full object-cover sm:h-64"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/70 to-transparent" />
            <div className="absolute inset-0 flex items-center">
              <div className="max-w-xl p-6 sm:p-10">
                <p className="font-mono text-[11px] tracking-[0.25em] text-brandamber">APRIL 26, 2027</p>
                <p className="mt-2 text-lg sm:text-xl font-semibold text-white leading-snug">
                  The DOJ's ADA Title II deadline hits state &amp; local government sites. Private businesses can be
                  sued under Title III <span className="text-alert">right now</span> — and already are, every day.
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
